import {useToast} from "~/composables/ui/useToast";

export function useApiErrorHandler(error: any){
    const { showToast } = useToast();


    if (error.errors?._network) {
        showToast("خطا اتصال", "مشکل در ارتباط با سرور، لطفاً اتصال اینترنت خود را بررسی کنید.", "warning")
        return;
    }
    const errors = Object.values(error.errors).flat().join('\n')
    showToast('خطا', errors, 'error');
    return;
}